import { useCreateQuestionMutation } from '@/api/questions/createQuestion';
import { useUpdateQuestionMutation } from '@/api/questions/updateQuestion';
import { createQuestionValidationSchema } from '@/validation/questionSchema';
import {
  QuestionFormValues,
  QuestionData,
  apiToFormValues,
  formValuesToCreatePayload,
  formValuesToUpdatePayload,
} from '@/utils/forms/questionTransformers';
import { useTimezoneStore } from '@/stores/timezoneStore';

interface UseQuestionFormProps {
  question?: QuestionData;
  questionId?: string;
  searchPickemId?: string;
  isNewQuestion: boolean;
}

export function useQuestionForm({
  question,
  questionId,
  searchPickemId,
  isNewQuestion,
}: UseQuestionFormProps) {
  const {
    mutate: createMutate,
    isPending: createIsPending,
    error: createError,
    isError: isCreateError,
  } = useCreateQuestionMutation();
  const {
    mutate: updateMutate,
    isPending: updateIsPending,
    error: updateError,
    isError: isUpdateError,
  } = useUpdateQuestionMutation();
  const { timezone } = useTimezoneStore();

  const initialValues = apiToFormValues(question, searchPickemId, timezone);

  // Create validation schema
  const validationSchema = createQuestionValidationSchema();

  const handleSubmit = (values: QuestionFormValues) => {
    if (isNewQuestion) {
      const payload = formValuesToCreatePayload(values, timezone);
      createMutate(payload);
    } else {
      if (!questionId) {
        return;
      }
      const payload = formValuesToUpdatePayload(questionId, values, timezone);
      updateMutate(payload);
    }
  };

  return {
    initialValues,
    validationSchema,
    handleSubmit,
    isPending: createIsPending || updateIsPending,
    error: isNewQuestion ? createError : updateError,
    isError: isNewQuestion ? isCreateError : isUpdateError,
  };
}
